import { BannerType } from './banner.types';
import { resolveBannerType } from './banner.resolver';
import { TwilioErrorBanner } from './banners/twilio-error-banner';
import { SuspensionWarningBanner } from './banners/suspension-warning-banner';
import { AccountSuspendedBanner } from './banners/account-suspended-banner';
import { CallNotSupportedBanner } from './banners/call-not-supported-banner';
import { NonRenewingBanner } from './banners/non-renewing-banner';
import { MicPermissionBanner } from './banners/mic-permission-banner';
import { ScheduledDowngradeBanner } from './banners/scheduled-downgrade-to-standard-banner';
import { WalletLowBanner } from './banners/low-balance-wallet-banner';
// import { WalletMediumLowBanner } from './banners/medium-low-balance-wallet';
import { InsufficientBalanceSuspendedBanner } from './banners/suspended-by-insufficient-balance-banner';
import { useAppBanner } from './banners/hooks/use-app-banner';
import { RateLimitBanner } from './banners/rate-limit-banner';
import { NotificationSilentBanner } from './banners/notification-silent-banner';
import { RiCloseLine } from 'react-icons/ri';
import { useState } from 'react';
import { MfaSetupReminderBanner } from './banners/mfa-setup-reminder-banner.tsx';
import { PreferredContactBanner } from './banners/preferred-contact-banner';
import { SwitchCallBanner } from './banners/switch-call-banner';
import { canDismissBanner } from './banners/helper/can-dismiss-banner.tsx';

const bannerMap: Record<BannerType, JSX.Element> = {
  [BannerType.TWILIO_ERROR]: <TwilioErrorBanner />,
  [BannerType.SWITCH_CALL]: <SwitchCallBanner />,
  [BannerType.ACCOUNT_SUSPENDED]: <AccountSuspendedBanner />,
  [BannerType.INSUFFICIENT_BALANCE_SUSPENDED]: <InsufficientBalanceSuspendedBanner />,
  [BannerType.SUSPENSION_WARNING]: <SuspensionWarningBanner />,
  [BannerType.RATE_LIMIT]: <RateLimitBanner />,
  [BannerType.CALL_NOT_SUPPORTED]: <CallNotSupportedBanner />,
  [BannerType.NON_RENEWING]: <NonRenewingBanner />,
  [BannerType.MIC_PERMISSION]: <MicPermissionBanner />,
  [BannerType.SCHEDULED_DOWNGRADE]: <ScheduledDowngradeBanner />,
  [BannerType.WALLET_LOW]: <WalletLowBanner />,
  // [BannerType.WALLET_MEDIUM_LOW]: <WalletMediumLowBanner />,
  [BannerType.NOTIFICATION_SILENT]: <NotificationSilentBanner />,
  [BannerType.MFA_SETUP_REMINDER]: <MfaSetupReminderBanner />,
  [BannerType.PREFERRED_CONTACT]: <PreferredContactBanner />,
};

export function AppBanner() {
  const appBanners = useAppBanner();
  const [dismissedBanners, setDismissedBanners] = useState<BannerType[]>(() => {
    return JSON.parse(localStorage.getItem('dismissed-app-banners') || '[]');
  });
  if (appBanners.bannerLoading) return null;
  const banner = resolveBannerType(appBanners, dismissedBanners);
  if (!banner) return null;
  const handleClose = () => {
    if (!banner) return;
    const nextDismissedBanners = [...dismissedBanners, banner];
    setDismissedBanners(nextDismissedBanners);
    localStorage.setItem('dismissed-app-banners', JSON.stringify(nextDismissedBanners));
  };

  return (
    <div className="relative [&_.app-alert_.ant-alert-content]:mr-5">
      {bannerMap[banner]}
      {canDismissBanner(banner) && (
        <button
          className="absolute right-3 top-1/2 z-10 -translate-y-1/2 cursor-pointer text-text-500 hover:text-text-700"
          onClick={handleClose}
        >
          <RiCloseLine className="size-5" />
        </button>
      )}
    </div>
  );
}
